// No imports: apiRequestError depends on this, so it must stay outside the sessionExpired import graph.

/**
 * True when a 401 means the app session itself was rejected. Backend errors carry a catalog
 * code (`{"error": "auth.token_expired"}`); only `auth.*` codes are session failures. Other 401s
 * (broker credentials, proxies) must not sign the user out. An unparseable body is treated as a
 * session failure so a real expiry still surfaces. Reads a clone so callers can still read the body.
 */
export async function isSessionAuthFailure(response: Response): Promise<boolean> {
  if (response.status !== 401) return false;
  try {
    const body: unknown = await response.clone().json();
    const code = (body as { error?: unknown } | null)?.error;
    if (typeof code !== "string") return true;
    return code.startsWith("auth.");
  } catch {
    return true;
  }
}
